/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Delete_FailedInputs */

const en_settings_apikeys_delete_failed = /** @type {(inputs: Settings_Apikeys_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete API key`)
};

/**
* | output |
* | --- |
* | "Failed to delete API key" |
*
* @param {Settings_Apikeys_Delete_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_delete_failed = /** @type {((inputs?: Settings_Apikeys_Delete_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Delete_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_delete_failed(inputs)
});
export { settings_apikeys_delete_failed as "settings.apikeys.delete_failed" }